<template>
  <q-page padding>
    <PageHeader
      title="Listagem de Reserva de Ferramentas"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 q-gutter-sm q-mt-md text-brand-5 text-weight-bold container-btn items-center"
    >
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Unidade</div>
        <ListaUnidadesSelect />
      </div>
      <div>
        <p></p>
        <router-link
          :to="{
            name: 'ferramentaria-reserva-ferramenta',
            params: { id: 0 },
          }"
        >
          <q-btn
            color="positive"
            class="btn q-mt-xs"
            no-caps
            label="Criar Reserva"
            icon="add"
          />
        </router-link>
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-mb-sm">
        <ComponenteFiltros
          :statusReserva="true"
          :classStatusReserva="'col-md col-xs-5'"
          :dataInicial="true"
          :classDataInicial="'col-md col-xs-6'"
          :solicitante="true"
          :classSolicitante="'col-md col-xs-6'"
          :dataFinal="true"
          :classDataFinal="'col-md col-xs-5'"
          @enviarFiltro="receberFiltro"
        />
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :columns="columns"
        :rows="listaReserva"
        :hide-bottom="!listaReserva.length == 0"
        dense
        no-data-label="Nenhuma reserva criada"
        table-header-class="bg-accent text-weight-bold"
        flat
        :class="{ 'my-sticky-dynamic': !mobile }"
        :grid="mobile"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-12">
            <q-card class="container-grid-table col-12">
              <div class="q-pa-sm">
                <div class="row col-12 items-center">
                  <div class="col">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Unidade:</strong>
                      <span> {{ props.row.unidadeId }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Nº Reserva:</strong>
                      <span> {{ props.row.numeroReserva }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Solicitante:</strong>
                      <span> {{ props.row.solicitanteNome }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Criado Em:</strong>
                      <span>
                        {{
                          `${props.row.criadoEm
                            ?.split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")} ${props.row.criadoEm?.split(" ")[1]}`
                        }}</span
                      >
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Contagem de ítens:</strong>
                      <span> {{ props.row?.itens?.length }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Status:</strong>
                      <div class="row items-center">
                        <div
                          v-if="props.row.finalizadoEm == null"
                          class="elipse q-mr-xs bg-warning"
                        ></div>
                        <div v-else class="elipse q-mr-xs bg-positive"></div>
                        <span
                          v-if="props.row.finalizadoEm == null"
                          class="row justify-center"
                        >
                          {{ "Em Aberta" }}
                        </span>
                        <span v-else class="row justify-center">
                          {{ "Finalizada" }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="row col-12 justify-end items-center">
                      <router-link
                        :to="{
                          name: 'ferramentaria-detalhe-reserva',
                          params: { reservaId: props.row.reservaUuid },
                        }"
                      >
                        <q-btn color="secondary" icon="article" round flat />
                      </router-link>
                      <div>
                        <q-btn
                          icon="delete"
                          flat
                          :disable="props.row.finalizadoEm != null"
                          color="red"
                          @click="
                            (confirm = true),
                              (reservaUuid = props.row.reservaUuid)
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              {{ props.row.unidadeId }}
            </q-td>
            <q-td>
              {{ props.row.numeroReserva }}
            </q-td>
            <q-td>
              {{ props.row.solicitanteNome }}
            </q-td>
            <q-td>
              <span class="row">
                {{
                  props.row?.criadoEm
                    ?.split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
              </span>
              <span class="row q-ml-sm">
                {{ props.row.criadoEm.split(" ")[1] }}
              </span>
            </q-td>
            <q-td>
              {{ props.row?.itens?.length }}
            </q-td>
            <q-td>
              <div
                :style="
                  props.row.finalizadoEm == null
                    ? 'background:#fefed1; width: fit-content; padding: 0px 5px'
                    : 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                "
                class="row items-center"
              >
                <div
                  v-if="props.row.finalizadoEm == null"
                  class="elipse q-mr-xs bg-warning"
                ></div>
                <div v-else class="elipse q-mr-xs bg-positive"></div>
                <span
                  v-if="props.row.finalizadoEm == null"
                  class="row justify-center text-brand-5"
                >
                  {{ "Em Aberta" }}
                </span>
                <span v-else class="row justify-center text-brand-5">
                  {{ "Finalizada" }}
                </span>
              </div>
            </q-td>
            <q-td>
              <router-link
                :to="{
                  name: 'ferramentaria-detalhe-reserva',
                  params: { reservaId: props.row.reservaUuid },
                }"
              >
                <q-btn color="secondary" icon="article" round flat />
              </router-link>
            </q-td>
            <q-td>
              <q-btn
                color="red"
                icon="delete"
                round
                :disable="props.row.finalizadoEm != null"
                flat
                @click="(confirm = true), (reservaUuid = props.row.reservaUuid)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div v-if="listaReserva.length > 0" class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
    <q-dialog v-model="confirm" persistent>
      <q-card
        class="q-pa-sm container-modal-excluir text-brand-5 text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai">TEM CERTEZA QUE DESEJA EXCLUIR?</span>
          <span class="texto-excluir-filho text-brand-5 q-mt-md q-mb-lg">
            Ao clicar em Excluir você estará deletando por definitivo a
            reserva.</span
          >
        </q-card-section>

        <div class="row col-12 justify-center">
          <q-btn
            no-caps
            label="Excluir"
            color="positive"
            v-close-popup
            class="btn-excluir"
            icon="check_circle_outline"
            @click="excluirReserva()"
          />
          <q-btn
            icon="cancel"
            no-caps
            label="Cancelar"
            color="negative"
            class="btn-excluir q-ml-md"
            v-close-popup
          />
        </div>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import ComponenteFiltros from "../components/ComponenteFiltros.vue";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "unidade",
    label: "Unidade",
    align: "left",
  },
  {
    name: "numeroReserva",
    label: "Nº Reserva",
    align: "left",
  },
  {
    name: "solicitante",
    label: "Solicitante",
    align: "left",
  },
  {
    name: "criadoEm",
    label: "Criado Em",
    align: "left",
  },
  {
    name: "contagemItens",
    label: "Contagem de Ítens",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "detalhes",
    label: "Detalhes",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];
export default {
  components: { ListaUnidadesSelect, ComponenteFiltros, PageHeader },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const listaReserva = ref([]);
    let loading = ref(false);
    let mobile = ref(false);
    let disable = ref(false);
    let confirm = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 6,
    });
    const solicitante = ref({});
    const reservaUuid = ref("");
    const filtros = ref({});

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarReserva = async (page = 1, rowsNumber = 15) => {
      await store.state.org.unidadeData.id;
      if (store.state.org.unidadeData.id == "") {
        listaReserva.value = [];
        return;
      }
      loading.value = true;
      disable.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarReservaCriada",
          {
            unidadeId: store.state.org.unidadeData.id,
            solicitanteId: filtros.value?.solicitante?.id,
            numeroReserva: filtros.value.numeroReserva || undefined,
            status: filtros.value?.statusReserva?.value,
            criadoEm: filtros.value?.dataInicial
              ?.split("/")
              .reverse()
              .join("-"),
            finalizadoEm: filtros.value?.dataFinal
              ?.split("/")
              .reverse()
              .join("-"),
            page: page,
            perPage: mobile.value ? 10 : rowsNumber,
          }
        );
        listaReserva.value = response.data.resultado.dados;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
        disable.value = false;
      }
    };

    const receberFuncionario = (value) => {
      solicitante.value = value;
    };

    const excluirReserva = async () => {
      try {
        await store.dispatch("ferramentaria/excluirReserva", {
          reservaUuid: reservaUuid.value,
        });
        listarReserva();
        quasar.notify({
          message: "Reserva excluída com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    };

    const receberFiltro = (value) => {
      filtros.value = value;
      listarReserva();
    };

    watch(
      () => pagination.value.page,
      () => {
        listarReserva(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    onMounted(() => {
      listarReserva();
    });

    return {
      columns,
      listaReserva,
      loading,
      disable,
      mobile,
      receberFuncionario,
      confirm,
      excluirReserva,
      reservaUuid,
      filtros,
      pagination,
      receberFiltro,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
tbody tr .coluna-btn {
  width: 120px;
}
a {
  text-decoration: none;
}
.my-sticky-dynamic {
  max-height: 400px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.container-modal-excluir {
  width: 590px;
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.texto-excluir-filho {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 100px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-btn {
    margin: 17px 0px 0px 0px;
  }
  .btn {
    font-size: 13px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .texto-excluir-filho {
    font-size: 14px;
  }
  .btn-excluir {
    font-size: 14px;
  }
}
</style>
